module.exports = __webpack_public_path__ + "img/Bodice-Front-B6-Da-Eb.43b4f2f6.png";